//import React from 'react';
import moment from "moment";
import React, { useState } from 'react';
import { dateStringFormat } from '../../../helpers/Tools';
import AttachmentModal from "./AttachmentModal";
import { replaceURLs, replacePhoneNumber, getInitials } from '../../../helpers/formatting';
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

export default function Message({ message, index, imageUrl }) {
    const [openAttachmentModal, setAttachmentModal] = useState(false);
    const toggleMessageModal = () => setAttachmentModal(prevState => {
        if (prevState) {
            window.removeEventListener("message", processWindowMsg, false)
        } else {
            window.addEventListener("message", processWindowMsg, false)
        }
        return !prevState
    });
    const processWindowMsg = (messageEvent) => {
        if (messageEvent && messageEvent.data === "dialog_closed") {
            setAttachmentModal(false);
            window.removeEventListener("message", processWindowMsg, false);
            logUI("MBHWeb.UI.CareCoach.Message.Event.DialogClosed", new Date(), Tools.getURLPath());
        }
    }
    const noteDate = message && message.noteDate ? message.noteDate : "";
    const formatDate = () => {
        if (!noteDate) return "";
        const messageDate = dateStringFormat(noteDate, "MM/DD/YYYY hh:mm A");
        return messageDate;
    };
    const attachments = message.attachments && message.attachments.length !== 0 ? message.attachments : [];
    let showAttachmentFormIcon, showAttachmentVedioIcon, showFormSubmittedMsg, showDefaultAttachmentIcon = false;
    let attachmentUrl = "";
    let attachmentClass = "";

    for (let i = 0; i <= attachments.length; i++) {
        if (attachments[i] && attachments[i].attachmentType === "twistle/form-definition") {
            showAttachmentFormIcon = true;
            attachmentUrl = attachments[i].attachmentFrameUrl;
            attachmentClass = "attachment-modal--form";
            break;
        } else if (attachments[i] && attachments[i].attachmentType === "video/mp4") {
            showAttachmentVedioIcon = true;
            attachmentUrl = attachments[i].attachmentFrameUrl;
            attachmentClass = "attachment-modal--video";
            break;
        } else if (attachments[i] && attachments[i].attachmentType === "twistle/form-submission") {
            showFormSubmittedMsg = true;
            break;
        } else if (attachments[i] && attachments[i].attachmentType === "application/pdf") {
            showDefaultAttachmentIcon = true;
            attachmentUrl = attachments[i].attachmentFrameUrl;
            attachmentClass = "attachment-modal--pdf";
            break;
        }else if (attachments[i] && attachments[i].attachmentType) {
            showDefaultAttachmentIcon = true;
            attachmentUrl = attachments[i].attachmentFrameUrl;
            break;
        }
    }

    const viewedDate = message && message.patientViewed ? moment(message.patientViewed) : false;
    let validDate = false;
    if (viewedDate && viewedDate.year().toString() !== "1") {
        validDate = true;
    }

    let msgCont = replaceURLs(message.messageContent);
    msgCont = replacePhoneNumber(msgCont);
    msgCont = msgCont && msgCont.replace(new RegExp('\n', 'g'), '</br>');
    const initials = message && message.authorFormalName ? getInitials(message.authorFormalName) : "";

    return (
        <div key={index} className="message-body">
            <div className="row">
                {!showFormSubmittedMsg ? <div className="col-12 conversation-messages">
                    <div className="icon-col">
                        <img className="journey-icon" alt="logo" src={imageUrl} />
                    </div>
                    <div className="conversation-info">
                        <div className="message-details">
                            {message.authorFormalName && <div className="message-subject">{message.authorFormalName}</div>}
                            <div className="conversation-note-date">{formatDate()}</div>
                        </div>
                        <div className="message-content" dangerouslySetInnerHTML={{ __html: msgCont }} />
                        {showAttachmentFormIcon && <button onClick={e => toggleMessageModal()} className="message-form-btn btn btn-primary">FILL OUT FORM</button>}
                        {showAttachmentVedioIcon && <button onClick={e => toggleMessageModal()} className="message-video-btn">
                            <span className="icon-video-camera message-video-icon" />
                        </button>}
                        {showDefaultAttachmentIcon && <button onClick={e => toggleMessageModal()} className="message-video-btn" >
                            <span className="icon-inbox-file message-video-icon" />
                        </button>}
                        {openAttachmentModal && <AttachmentModal attachmentUrl={attachmentUrl} toggleAttachmentModal={toggleMessageModal} contentClassName={attachmentClass} />}
                    </div>
                    {validDate && <div className="icon-col-right">
                        <span className="icon-check-mark-chat icon-check-position" />
                    </div>}
                </div> :
                    <div className="col-12 conversation-messages">
                        <div className="conversation-info conversation-info-form">
                            <div className="message-details message-details-form">
                                <span className="message-subject">{message.authorFormalName}</span>
                                <span className="conversation-note-date">{formatDate()}</span>
                            </div>
                            <div className="message-content message-content-form">You succcessfully submitted your form.</div>
                            <div className="message-form-icon">
                                <img src="/images/message-form-icon.svg" alt="form" />
                            </div>
                        </div>
                        <div className="icon-col-right icon-col-right-form">
                            <span className="icon-user-name">{initials}</span>
                        </div>
                    </div>}
             </div>
        </div>
    );
}